// extracted by mini-css-extract-plugin
export default {"button-custom":"table_button-custom__2Ofts","favorite-project-switch":"table_favorite-project-switch__MBUiX"};